import { lazy } from 'react'
import serverData from '../utils/server-data'
import DeletionFeedback from '../modals/dataPrivacy/data-deletion/feedback'
import Deletionemail from '../modals/dataPrivacy/data-deletion/email'
import DataDeletion from '../modals/dataPrivacy/data-deletion/introduction'
import DeletionSuccess from '../modals/dataPrivacy/data-deletion/success'
import {
  LoggedOutConfirmEmail,
  LoggedOutDsrForm,
  LoggedOutWelcome,
  Status,
  LoggedOutTrackYourData,
} from '../modals/dataPrivacy/logged-out-data-access'

import PasswordRecoveryHomeScreen from '../modals/dataPrivacy/password-recovery/HomeScreen'

import Verification from '../modals/dataPrivacy/logged-out-data-access/verification'
import LinkedAccounts from '../modals/dataPrivacy/data-deletion/linked-accounts'
import { hasTreatmentName } from '../utils'
const { closeUrl = null, backUrl = null, showBackButton = true } = serverData

const getDarSourceFile = () => {
  return lazy(() =>
    hasTreatmentName('Trmt_Manage_EDPB_Dar_Changes')
      ? import('../modals/dataPrivacy/data-access/EdpbDarForm')
      : import('../modals/dataPrivacy/data-access/request-form'),
  )
}

export default {
  '/data/dar': {
    view: getDarSourceFile(),
    props: {
      closeUrl,
      domid: 'request_form_modal',
    },
  },

  '/data/correctionpage': {
    view: lazy(() => import('../modals/dataPrivacy/data-correction/index')),
    props: {
      closeUrl,
      domid: 'correction_page',
    },
  },

  '/data/correction': {
    //merchant correction page
    view: lazy(() =>
      import('../modals/dataPrivacy/data-correction/merchant-correction'),
    ),
    props: {
      closeUrl,
      domid: 'merchant_correction',
    },
  },

  '/data/dar/yourrequests': {
    view: lazy(() =>
      import('../modals/dataPrivacy/data-access/request-history'),
    ),
    props: {
      closeUrl,
      domid: 'your_requests_modal',
    },
  },

  '/data/dar/2fareturn': {
    view: getDarSourceFile(),
    props: {
      closeUrl,
      redirect: 'authweb',
      domid: 'authweb_request_form_modal',
    },
  },

  '/data/deletion': {
    view: lazy(() =>
      import('../modals/dataPrivacy/data-deletion/introduction'),
    ),
    props: {
      slides: [
        DataDeletion,
        LinkedAccounts,
        DeletionFeedback,
        Deletionemail,
        DeletionSuccess,
      ],
      closeUrl,
      domid: 'data_deletion_modal',
    },
  },

  '/data/deletion/2fareturn': {
    view: lazy(() =>
      import('../modals/dataPrivacy/data-deletion/introduction'),
    ),
    props: {
      redirect: 'authweb',
      slides: [
        DataDeletion,
        LinkedAccounts,
        DeletionFeedback,
        Deletionemail,
        DeletionSuccess,
      ],
      position: 3,
      closeUrl,
      domid: 'authweb_deletion_modal',
    },
  },

  '/cookiePrefs': {
    view: lazy(() => import('./home/CookiePrefsSettings')),
    props: {
      showBackButton: false,
      closeUrl,
      domid: 'cookiePrefsModal',
    },
  },
  '/showNotice': {
    view: lazy(() => import('./home/NoticeSettings')),
    props: {
      showBackButton: false,
      closeUrl,
    },
  },
  '/searchPrivacy': {
    view: lazy(() => import('../modals/search-privacy')),
    props: {
      showBackButton,
      backUrl,
      closeUrl,
      domid:
        serverData.selectedComponent === 'SIMPLIFIED'
          ? 'search-privacy-simplified'
          : 'search-privacy-granular',
    },
  },
  '/personalization/paypal': {
    view: lazy(() => import('../modals/personalization/PaypalPersonalization')),
    props: {
      showBackButton,
      backUrl,
      closeUrl,
    },
  },

  '/personalization/other': {
    view: lazy(() => import('../modals/personalization/OtherPersonalization')),
    props: {
      showBackButton,
      backUrl,
      closeUrl,
    },
  },
  '/common/pypl': {
    props: {
      slides: [LoggedOutWelcome, LoggedOutDsrForm, LoggedOutConfirmEmail],
      closeUrl,
      domid: 'logged_out_modal',
    },
  },
  '/common/pypl/trackrequest': {
    props: {
      slides: [LoggedOutTrackYourData, Status],
      closeUrl,
      domid: 'data_track_modal',
    },
  },
  '/common/pypl/verification': {
    props: {
      closeUrl,
      domid: 'data_verify_modal',
      slides: [Verification],
    },
  },
  '/common/password-recovery': {
    props: {
      closeUrl: '',
      domid: 'password_recovery_modal',
      slides: [PasswordRecoveryHomeScreen],
    },
  },
  // Use this screen mapper to load the full page modal window
}
